import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import LeadsTable from "../../components/leads/LeadTable/LeadsTable";
import useCustomerDetails from "../../data/useCustomerDetails";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { LeadStatus } from "../../models/Lead";

export default function Quotes() {
  const navigate = useNavigate();
  const { setInfo } = usePageNameContext();
  const { features } = useCustomerDetails();
  const isCallCentre = useMemo(
    () => !!features.data?.data?.find((f) => f.name === "Call Centre"),
    [features.data]
  );

  useEffect(() => {
    if (!features.isLoading && !isCallCentre) {
      navigate("/", { replace: true });
      return;
    }

    setInfo({
      name: "Quotes",
      desc: "View and manage call list quotes",
    });
  }, [features.isLoading, isCallCentre, navigate]);

  const additionalBody = useMemo(
    () => ({
      Status: [LeadStatus["Call List"]],
      AwaitingCod: true,
      IncludeCompleted: false,
      DocumentFilter: 6, // All
    }),
    []
  );

  if (!isCallCentre) return null;

  return <LeadsTable additionalBody={additionalBody} />;
}
